import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip, Typography } from '@mui/material';
import type { BackupPolicyConfig } from '@repo/api-gw-sdk';
import type { BackupVault } from '@/data/vaults/backupVault';
import { useBackupVaults } from '@/data/vaults/useBackupVaults';
import { BackupPolicyPopperCard } from './BackupPolicyPopperCard';
import { SnapshotIndicator } from '../snapshots/SnapshotIndicator';
interface BackupPolicyTagProps {
  policy: BackupPolicyConfig;
  disableTooltip?: boolean;
}
export function BackupPolicyTag(t0) {
  const $ = _c(25);
  const {
    policy,
    disableTooltip
  } = t0;
  const {
    vaults,
    isLoading: isLoadingVaults
  } = useBackupVaults();
  let t1;
  if ($[0] !== policy.schedules) {
    t1 = Array.from(new Set(policy.schedules.map(_temp)));
    $[0] = policy.schedules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const distinctVaults = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      tooltip: {
        sx: {
          maxWidth: "400px",
          backgroundColor: "transparent"
        }
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLoadingVaults || $[4] !== policy || $[5] !== vaults) {
    t3 = !isLoadingVaults ? <BackupPolicyPopperCard policy={policy} vaults={vaults} /> : undefined;
    $[3] = isLoadingVaults;
    $[4] = policy;
    $[5] = vaults;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = policy.enabled ? "var(--mui-palette-primary-main)" : "transparent";
  const t5 = policy.enabled ? "transparent" : "var(--mui-palette-background-disabled)";
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: t4,
      backgroundColor: t5,
      borderRadius: "4px",
      padding: "4px 8px"
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== distinctVaults || $[11] !== isLoadingVaults || $[12] !== vaults) {
    t7 = !isLoadingVaults && distinctVaults.map((vid, index) => {
      const v_0 = vaults.find(v => v.id === vid);
      return <SnapshotIndicator key={index} backgroundColor={v_0?.backgroundColor || null} />;
    });
    $[10] = distinctVaults;
    $[11] = isLoadingVaults;
    $[12] = vaults;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      fontSize: "12px"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== policy.name) {
    t9 = <Typography component="span" variant="subtitle2" sx={t8}>{policy.name}</Typography>;
    $[15] = policy.name;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
    t10 = <Stack direction="row" sx={t6}>{t7}{t9}</Stack>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== disableTooltip || $[22] !== t10 || $[23] !== t3) {
    t11 = <><Tooltip disableHoverListener={disableTooltip} disableInteractive={false} leaveTouchDelay={2000} disableFocusListener={true} slotProps={t2} title={t3}>{t10}</Tooltip></>;
    $[21] = disableTooltip;
    $[22] = t10;
    $[23] = t3;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp(schedule) {
  return schedule.vaultId;
}